import { render, staticRenderFns } from "./gridLink.vue?vue&type=template&id=bf5c1054&scoped=true&"
import script from "./gridLink.vue?vue&type=script&lang=js&"
export * from "./gridLink.vue?vue&type=script&lang=js&"
import style0 from "./gridLink.vue?vue&type=style&index=0&id=bf5c1054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5c1054",
  null
  
)

export default component.exports